import React from 'react';
import { toast } from 'sonner';
import { Panel, Empty, Badge } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { api, errMsg, fmtUsd } from '../../lib/api';

const ROLES = ['user', 'support', 'auditor', 'compliance_admin', 'trading_ops_admin', 'finance_admin', 'super_admin'];

export default function AdminUsers() {
  const { data: users, reload } = useFetch('/admin/users');
  const setRole = async (id, role) => {
    try { await api.post(`/admin/users/${id}/role`, { role }); toast.success('Role updated'); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div data-testid="admin-users">
      <Panel title="User Management">
        {users && users.length ? (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-vj-grey border-b border-border"><th className="py-2 font-medium">Name</th><th className="font-medium">Email</th><th className="font-medium">Country</th><th className="font-medium">Deposits</th><th className="font-medium">Allocation</th><th className="font-medium">Role</th></tr></thead>
            <tbody>{users.map((u) => (
              <tr key={u.id} className="border-b border-border last:border-0">
                <td className="py-2.5">{u.name}</td>
                <td className="text-xs">{u.email}</td>
                <td className="text-xs text-vj-grey">{u.country}</td>
                <td className="font-mono text-xs">{fmtUsd(u.total_deposits)}</td>
                <td className="font-mono text-xs text-vj-gold">{fmtUsd(u.allocation)}</td>
                <td>
                  <select value={u.role} onChange={(e) => setRole(u.id, e.target.value)} className="h-8 px-2 rounded-md bg-vj-charcoal border border-border text-xs text-foreground" data-testid={`role-${u.id}`}>
                    {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                  </select>
                </td>
              </tr>
            ))}</tbody>
          </table></div>
        ) : <Empty>No users.</Empty>}
      </Panel>
    </div>
  );
}
